import gql from 'graphql-tag';

export default gql`
  fragment organizationFragment on Organization {
    _id
    title
    description
    createdAt
    subscribed
    mainUserId
    numberOfDashboards
    mainUser {
      _id
      emails {
        address
      }
      profile {
        firstName
        lastName
      }
    }
    numberOfUsers
  }
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Fragments/organizationFragment.js